import { AsButton, AsInput, PaymentModalHeader } from "app/subframe";
import { motion } from "framer-motion";
import * as React from "react";
import { useCreditCardPaymentModal } from "./useCreditCardPaymentModal";
import { Loading } from "app/components/loading/loading";
import classNames from "classnames";
import CreditCardFormModal from "../../../../components/dejavoo/cardDetailsModal";
import {useState} from "react";

export interface CreditCardPaymentModalProps {
  setIsCreditCardPaymentModalOpen: (open: boolean) => void;
  isProcessingCreditCardCharge: boolean;
  onPayWithCreditCard: (ref: any) => void;
}
export const CreditCardPaymentModal: React.FC<CreditCardPaymentModalProps> = ({
                                                                                  setIsCreditCardPaymentModalOpen,
                                                                                  isProcessingCreditCardCharge,
                                                                                  onPayWithCreditCard,
                                                                              }) => {
    const { cardFormRef, account } = useCreditCardPaymentModal();

    const [isValidated, setIsValidated] = useState(false)
    const [cardData, setCardData] = useState<any>({})

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm">

            {isProcessingCreditCardCharge && (
                <div className="absolute top-1/3">
                    <Loading
                        label="Processing payment"
                        labelClassName="text-white"
                        type="brand"
                    />
                </div>
            )}

            <motion.div
                initial={{ scale: 0.95, opacity: 0 }}
                animate={{ scale: 1, opacity: 1 }}
                transition={{ duration: 0.2, ease: "easeInOut" }}
                className={classNames(
                    "flex w-[600px] max-w-full rounded-lg flex-col items-center gap-6 bg-white p-4 shadow-pop-up-shadow",
                    {
                        invisible: isProcessingCreditCardCharge,
                    }
                )}
            >
                <PaymentModalHeader
                    text="Pay on app"
                    buttonProps={{
                        onClick: () => setIsCreditCardPaymentModalOpen(false),
                    }}
                />

                <CreditCardFormModal
                    onCardValidationSuccess={(res) => {setCardData(res)}}
                    secretKey={account.iposAuthToken}
                    freedomURL={process.env.REACT_APP_IPOS_FREEDOM_CREDIT_URL!}
                />

                <AsButton
                    // disabled={isProcessingCreditCardCharge }
                    disabled={!cardData?.payment_token_id || isProcessingCreditCardCharge}
                    className="h-14 w-full"
                    variant="default"
                    text="Pay now"
                    size="lg"
                    loader={isProcessingCreditCardCharge}
                    onClick={()=>onPayWithCreditCard(cardData)}
                />
            </motion.div>
        </div>
    );
};
